<template>
  <div class="home">
    This is index app route
  </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'app.index',
    components: {

    }
};
</script>
